const getTextSurroundingRange = (root, range) => {
  const preRange = range.cloneRange()
  preRange.selectNodeContents(root)
  preRange.setEnd(range.startContainer, range.startOffset)

  const postRange = range.cloneRange()
  postRange.selectNodeContents(root)
  postRange.setStart(range.endContainer, range.endOffset)

  return {
    textBeforeCaret: preRange.toString(),
    textAfterCaret: postRange.toString()
  }
}

const autocompleteInsertionText = (completion, textAfterCaret) => {
  const normalized = String(completion || '').trim()
  if (!normalized) return ''
  return normalized + (textAfterCaret ? '' : ' ')
}

module.exports = {
  autocompleteInsertionText,
  getTextSurroundingRange
}
